export default function Security() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="security" className="relative min-h-screen flex items-center justify-center overflow-hidden py-32">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c6b5bcf87658639ec547c69976ecdfca.jpg"
          alt="Security Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/60 to-black/70"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <h2 className="text-7xl font-bold text-white leading-tight">
              Your Privacy<br />Matters
            </h2>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-teal-400 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">No Activity Logs</h3>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    We never track, collect, or store your online activities. Your browsing history remains completely private.
                  </p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-purple-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-eye-off-line text-purple-400 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Anonymous Browsing</h3>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    Your real IP address is hidden, making it impossible for websites and trackers to identify you.
                  </p>
                </div>
              </div>
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-orange-500/20 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-lock-password-line text-orange-400 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">Advanced Encryption</h3>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    Military-grade AES-256 encryption ensures your data is protected from hackers and surveillance.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-8 text-white">
            <div className="bg-white/10 backdrop-blur-md rounded-3xl p-10 border border-white/20">
              <h3 className="text-3xl font-bold mb-6">Security Features</h3>
              <ul className="space-y-4">
                <li className="flex items-center space-x-3">
                  <i className="ri-checkbox-circle-fill text-teal-400 text-xl"></i>
                  <span className="text-base">Kill Switch Protection</span>
                </li>
                <li className="flex items-center space-x-3">
                  <i className="ri-checkbox-circle-fill text-teal-400 text-xl"></i>
                  <span className="text-base">DNS Leak Prevention</span>
                </li>
                <li className="flex items-center space-x-3">
                  <i className="ri-checkbox-circle-fill text-teal-400 text-xl"></i>
                  <span className="text-base">Split Tunneling</span>
                </li>
                <li className="flex items-center space-x-3">
                  <i className="ri-checkbox-circle-fill text-teal-400 text-xl"></i>
                  <span className="text-base">Automatic Wi-Fi Protection</span>
                </li>
                <li className="flex items-center space-x-3">
                  <i className="ri-checkbox-circle-fill text-teal-400 text-xl"></i>
                  <span className="text-base">Multi-Protocol Support</span>
                </li>
              </ul>
            </div>

            <div className="text-center lg:text-left">
              <p className="text-2xl font-thin text-white mb-2">Zero logs. Zero tracking.</p>
              <p className="text-2xl font-thin text-white mb-8">Complete anonymity guaranteed.</p>
              <button
                onClick={() => scrollToSection('contact')}
                className="inline-flex items-center space-x-4 bg-white text-gray-900 px-10 py-4 rounded-full text-base font-semibold hover:bg-gray-100 transition-all hover:scale-105 shadow-xl whitespace-nowrap"
              >
                <span>Get Protected Now</span>
                <div className="w-10 h-10 bg-gray-900 rounded-full flex items-center justify-center">
                  <i className="ri-arrow-right-line text-white text-lg"></i>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
